import type { ParsedFirstFile } from './firstFileConfiguration';

interface FirstFileSource {
	file: File;
	parsed: ParsedFirstFile;
}

export type FirstFileUploadState =
	| (FirstFileSource & { phase: 'configuring' })
	| (FirstFileSource & { phase: 'uploading'; configuredFacilityId: number })
	| (FirstFileSource & { phase: 'uploadFailed'; configuredFacilityId: number });

type UploadingFirstFileState = Extract<FirstFileUploadState, { phase: 'uploading' }>;

export function createFirstFileUpload(file: File, parsed: ParsedFirstFile): FirstFileUploadState {
	return { file, parsed, phase: 'configuring' };
}

export function beginFirstFileUpload(
	firstFile: FirstFileSource,
	configuredFacilityId: number
): UploadingFirstFileState {
	return { ...firstFile, configuredFacilityId, phase: 'uploading' };
}

export function completeFirstFileUpload(
	firstFile: UploadingFirstFileState,
	uploadSucceeded: boolean
): FirstFileUploadState | null {
	return uploadSucceeded ? null : { ...firstFile, phase: 'uploadFailed' };
}

export async function runFirstFileUploadAttempt(
	firstFile: FirstFileSource,
	configuredFacilityId: number,
	upload: (file: File, facilityId: number) => Promise<boolean>,
	onStateChange: (state: FirstFileUploadState | null) => void
): Promise<boolean> {
	const uploading = beginFirstFileUpload(firstFile, configuredFacilityId);
	onStateChange(uploading);

	const uploadSucceeded = await upload(uploading.file, uploading.configuredFacilityId);
	onStateChange(completeFirstFileUpload(uploading, uploadSucceeded));
	return uploadSucceeded;
}
